import { render, staticRenderFns } from "./CurrentPatientForm.vue?vue&type=template&id=093fa6c4&scoped=true"
import script from "./CurrentPatientForm.vue?vue&type=script&lang=js"
export * from "./CurrentPatientForm.vue?vue&type=script&lang=js"
import style0 from "./CurrentPatientForm.vue?vue&type=style&index=0&id=093fa6c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093fa6c4",
  null
  
)

export default component.exports